import http from '@/plugins/axios';
import { CONSTS } from '@/helpers/consts';

export default {
  getImportEntries: ({ rowsPerPage, sortBy, descending, page, search }) => {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy,
      orderDirection: descending ? 'desc' : 'asc',
      search: search,
    };
    return http
      .get('/import-entries', {
        params,
      })
      .then(res => res.data);
  },
  closeErrorMessage: entryId => {
    return http.post(`review-import-entries/${entryId}/close-error-message`);
  },
  deleteImportedReviews: productId => {
    return http.post(`review-import-entries/${productId}/delete`);
  },
  getImportDeleteStatus: productId => {
    return http.get(`review-import-entries/${productId}/delete-status`);
  },
  deleteReview: reviewId => {
    return http.post(`unlinked-reviews/${reviewId}/delete`);
  },
  changeAutoSyncStatus(entryId) {
    return http.post(`review-import-entries/${entryId}/change-auto-sync`);
  },
  syncLatestImports(productId) {
    return http.post(`review-import-entries/${productId}/sync-latest`);
  },
  retryImport(entryId) {
    return http.post(`review-import-entries/${entryId}/retry`);
  },
  searchProduct(search) {
    const params = {
      search,
    };
    return http.get('products', {
      params,
    });
  },
  newImportReviews(
    {
      productId,
      importExternalId,
      region,
      reviewStarSubset,
      howManyReviews,
      howManyRatings,
      translateReviews,
      importOnlyWithImages,
      importAllReviews,
      importRatings,
      minimumWords,
      automaticSync,
      autoApprove,
      obfuscateReviewerName,
    },
    source
  ) {
    const params = {
      importExternalId,
      region,
      reviewStarSubset,
      howManyReviews: howManyReviews || 0,
      howManyRatings: howManyRatings || 0,
      translateReviews,
      importOnlyWithImages: !!importOnlyWithImages,
      importAllReviews: !!importAllReviews,
      importRatings: !!importRatings,
      minimumWords: minimumWords === '' ? null : minimumWords,
      automaticSync: !!automaticSync,
      autoApprove: !!autoApprove,
      obfuscateReviewerName: !!obfuscateReviewerName,
    };

    if (source == CONSTS.service.aliexpress) {
      params.importOnlyThisLanguage = null;
    }

    return http.post(`products/${productId}/imports/${source.toLowerCase()}`, {
      ...params,
    });
  },
  editImport({
    importEntryId,
    reviewStarSubset,
    howManyReviews,
    howManyRatings,
    translateReviews,
    importOnlyWithImages,
    importRatings,
    minimumWords,
    automaticSync,
    autoApprove,
    obfuscateReviewerName,
  }) {
    const params = {
      reviewStarSubset,
      howManyReviews,
      howManyRatings,
      translateReviews,
      importOnlyWithImages,
      importOnlyThisLanguage: null,
      importRatings: !!importRatings,
      minimumWords: minimumWords === '' ? null : minimumWords,
      automaticSync: !!automaticSync,
      autoApprove: !!autoApprove,
      obfuscateReviewerName: !!obfuscateReviewerName,
    };
    return http.post(`review-import-entries/${importEntryId}/edit`, params);
  },
  importEbaySellerReviews({
    importExternalId,
    region,
    reviewStarSubset,
    howManyReviews,
    translateReviews,
    minimumWords,
    automaticSync,
    autoApprove,
    obfuscateReviewerName,
  }) {
    const params = {
      importExternalId,
      region,
      reviewStarSubset,
      howManyReviews,
      translateReviews,
      minimumWords: minimumWords === '' ? null : minimumWords,
      automaticSync: !!automaticSync,
      autoApprove: !!autoApprove,
      obfuscateReviewerName: !!obfuscateReviewerName,
    };

    return http.post('ebay-seller/import-reviews', {
      ...params,
    });
  },
  importAmazonSellerReviews({
    marketplaceId,
    sellerId,
    region,
    reviewStarSubset,
    howManyReviews,
    translateReviews,
    minimumWords,
    automaticSync,
    autoApprove,
    obfuscateReviewerName,
  }) {
    const params = {
      marketplaceId,
      sellerId,
      region,
      reviewStarSubset,
      howManyReviews,
      translateReviews,
      minimumWords: minimumWords === '' ? null : minimumWords,
      automaticSync: !!automaticSync,
      autoApprove: !!autoApprove,
      obfuscateReviewerName: !!obfuscateReviewerName,
    };

    return http.post('amazon-seller/import-reviews', {
      ...params,
    });
  },
  getUnlinkedAmazonReviews: ({ rowsPerPage, search, sortBy, descending, page }, source) => {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      search: search,
      length: rowsPerPage,
      order: sortBy,
      orderDirection: descending ? 'desc' : 'asc',
    };

    return http
      .get(source + '/unlinked-reviews', {
        params,
      })
      .then(res => res.data);
  },
  getUnlinkedImports: ({ rowsPerPage, search, sortBy, descending, page }) => {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      search: search,
      length: rowsPerPage,
      order: sortBy,
      orderDirection: descending ? 'desc' : 'asc',
    };
    return http
      .get('/unlinked-import-entries', {
        params,
      })
      .then(res => res.data);
  },
  linkToProduct(importId, productId) {
    const params = {
      importId,
      productId,
    };

    return http.post('link-import-to-product', {
      ...params,
    });
  },
  linkReviewToProduct(reviewId, productId) {
    const params = {
      reviewId,
      productId,
    };

    return http.post('link-review-to-product', {
      ...params,
    });
  },
  deleteAllUnlinkedEntries() {
    return http.post('review-import-entries/delete-all-unlinked', {});
  },
  deleteAllUnlinkedReviews(source) {
    return http.post('reviews/' + source + '/delete-all-unlinked', {});
  },
  loadImportEntryUnpublishedReviews(importEntryId, { rowsPerPage, sortBy, descending, page }) {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy,
      orderDirection: descending ? 'desc' : 'asc',
    };
    return http
      .get(`/import-entries/${importEntryId}/unpublished-reviews`, {
        params,
      })
      .then(res => res.data);
  },
  approveReview(reviewId) {
    return http.post(`/reviews/${reviewId}/publish`, {});
  },
  //820 notes: unused code removed
  // deleteReview(reviewId) {
  //   return http.post(`/reviews/${reviewId}/delete`, {});
  // },
  approveAllImportEntryReviews(importEntryId) {
    return http.post(`/import-entries/${importEntryId}/publish-all-reviews`, {});
  },
  getProductReviewsTable: productId =>
    http.get('/products/' + productId + '/reviews-imports-product-info').then(res => {
      return res.data;
    }),
};
